export default {
	methods: {
		myLang: function (...arg) {
			return lang.get(...arg);
		}
	}
}
